import { ConditionalStrategy, StrategySafe } from 'utility-ts-strategy';

interface IAPApiUrlStrategy {
  url: string;
}

type UserRole = 'advisor' | 'student';

export const RemoveCourseFromTermAndAddCourseCommandUrlStrategy = new StrategySafe<IAPApiUrlStrategy, UserRole>({
  advisor: {
    url: '/reg/advisorplan/'
  },
  student: {
    url: '/reg/academicplan/'
  }
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/global/strategies/ap_command_url_strategy.ts